import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'theme';

// Defaults to light regardless of the OS's prefers-color-scheme - only an
// explicit toggle() switches to dark, and that choice is what's remembered.
@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private readonly isDarkSubject = new BehaviorSubject<boolean>(this.computeIsDark());
    public readonly isDark$ = this.isDarkSubject.asObservable();

    constructor() {
        this.applyStoredPreference();
    }

    public toggle(): void {
        const next = this.isDarkSubject.value ? 'light' : 'dark';
        localStorage.setItem(STORAGE_KEY, next);
        document.documentElement.setAttribute('data-theme', next);
        this.isDarkSubject.next(next === 'dark');
    }

    private applyStoredPreference(): void {
        const stored = localStorage.getItem(STORAGE_KEY);
        document.documentElement.setAttribute('data-theme', stored === 'dark' ? 'dark' : 'light');
    }

    private computeIsDark(): boolean {
        return localStorage.getItem(STORAGE_KEY) === 'dark';
    }
}
